export default __webpack_public_path__ + "static/media/product-12 (1).d3308813.jpg";